import React from 'react';
import { Section } from './ui/Section';
import { MessageCircle, Ear } from 'lucide-react';
export function InsightSection() {
  return <Section background="stone" data-id="element-95">
      <div className="text-center mb-8" data-id="element-96">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-stone-900 mb-3" data-id="element-97">
          El insight que cambia todo
        </h2>
        <p className="text-base text-stone-600 max-w-2xl mx-auto" data-id="element-98">
          Cuando una conversación se rompe, casi siempre pasa esto:
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-4 md:gap-8 items-center max-w-3xl mx-auto" data-id="element-99">
        {/* You speak */}
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-stone-100 relative" data-id="element-100">
          <div className="absolute -top-3 left-6 bg-stone-800 text-white px-3 py-1 rounded-full text-xs font-medium flex items-center gap-2" data-id="element-101">
            <MessageCircle size={14} data-id="element-102" /> Tú hablas desde
          </div>
          <ul className="space-y-2 mt-2" data-id="element-103">
            <li className="text-stone-700 font-medium text-base" data-id="element-104">
              ✨ Solución
            </li>
            <li className="text-stone-700 font-medium text-base" data-id="element-105">🧠 Lógica</li>
            <li className="text-stone-700 font-medium text-base" data-id="element-106">⚡ Rapidez</li>
            <li className="text-stone-700 font-medium text-base" data-id="element-107">
              ✅ Eficiencia
            </li>
          </ul>
        </div>

        {/* They hear */}
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-stone-100 relative" data-id="element-108">
          <div className="absolute -top-3 right-6 bg-orange-700 text-white px-3 py-1 rounded-full text-xs font-medium flex items-center gap-2" data-id="element-109">
            Ellos escuchan <Ear size={14} data-id="element-110" />
          </div>
          <ul className="space-y-2 mt-2 text-right" data-id="element-111">
            <li className="text-stone-700 font-medium text-base" data-id="element-112">Juicio ⚖️</li>
            <li className="text-stone-700 font-medium text-base" data-id="element-113">Apuro 🏃‍♂️</li>
            <li className="text-stone-700 font-medium text-base" data-id="element-114">
              Pérdida de autoridad 📉
            </li>
            <li className="text-stone-700 font-medium text-base" data-id="element-115">
              Vergüenza 😔
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-8 text-center max-w-2xl mx-auto" data-id="element-116">
        <p className="text-lg md:text-xl font-serif text-stone-800 leading-relaxed" data-id="element-117">
          Entonces tú subes la explicación… <br data-id="element-118" />y ellos suben la defensa.
        </p>
        <p className="mt-3 text-base text-orange-800 font-medium" data-id="element-119">
          Por eso, aunque tengas razón, pierdes.
        </p>
      </div>
    </Section>;
}